export const hd = ([item]) => item
